import { Component, input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomFormControl } from '../../../../classes/custom-form-control.class';
import { passwordValidator } from '../../../../validators/password.validator';
import { forbiddenInputsValidator } from '../../../../validators/forbidden-inputs.validator';

@Component({
  selector: 'mono-common-password-input',
  templateUrl: './password-input.component.html',
  standalone: true
})
export class PasswordInputComponent extends CustomFormControl {

  public forbiddenPasswords = input<string[]>([]);

  constructor() {
    super();
  }

  protected createFormControl(): FormControl {
    return new FormControl('', [
      Validators.required,
      Validators.minLength(12),
      Validators.maxLength(99),
      passwordValidator,
      forbiddenInputsValidator(this.forbiddenPasswords())
    ]);
  }

}